import script from "./index.vue?vue&type=script&setup=true&lang=jsx"
export * from "./index.vue?vue&type=script&setup=true&lang=jsx"

import "./index.vue?vue&type=style&index=0&id=7ddb84ee&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ddb84ee"]])

export default __exports__